import React from "react";
import { object, func } from "prop-types";

const ListicleStory = ({ story, config, adWidget, adPlaceholder, hasAccess }) => {
  const templateSpecific = { templateType: "headline-sideway" };

  return <></>;
};

ListicleStory.propTypes = {
  story: object,
  config: object,
  adWidget: func,
  adPlaceholder: object,
  hasAccess: func,
};

export default ListicleStory;
